/**
 * @flow
 * @relayHash 2e146fc30e972211b70a11e4a17ed1c1
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type updateHyeventInput = {|
  clientMutationId?: ?string,
  id: string,
  title?: ?string,
  maxNoOfGuests?: ?number,
  maxAdditionalGuests?: ?number,
  ctaText?: ?string,
  messageTitle?: ?string,
  message?: ?string,
  address?: ?string,
  placeName?: ?string,
  propertyId: string,
  startAt?: ?string,
  endAt?: ?string,
  imageData?: ?string,
  eventType: string,
  zoomLink: string,
  meetingId: string,
  passcode: string,
  displayTime?: ?string,
  docData?: ?string,
  smsConfirmationText?: ?string,
  fields?: ?$ReadOnlyArray<?string>,
  rsvpFormHeader?: ?string,
  recurringEventType?: ?string,
  repeatType?: ?string,
  recurrenceType?: ?string,
  recurrenceEndDate?: ?string,
  recurringDaysList?: ?string,
  pdfFileName?: ?string,
|};
export type updateEventMutationVariables = {|
  input: updateHyeventInput
|};
export type updateEventMutationResponse = {|
  +updateHyevent: ?{|
    +clientMutationId: ?string,
    +hyevent: ?{|
      +address: string,
      +additionalGuestAllowed: boolean,
      +approvedAt: ?any,
      +approverName: ?string,
      +cancelReason: ?string,
      +cancelledAt: ?any,
      +confirmPageHtml: ?string,
      +cancelRsvpPageHtml: ?string,
      +waitlistedPageHtml: ?string,
      +removeFromWaitlistPageHtml: ?string,
      +confirmSmsBody: ?string,
      +createdAt: any,
      +ctaText: string,
      +disapproveReason: ?string,
      +endAt: any,
      +flyerHtml: ?string,
      +id: string,
      +campaignTested: ?boolean,
      +image: {|
        +createdAt: any,
        +dimension: ?string,
        +fileSize: number,
        +fileType: string,
        +fileUrl: string,
        +id: string,
        +name: string,
        +thumbnailUrl: ?string,
      |},
      +document: ?{|
        +createdAt: any,
        +dimension: ?string,
        +fileSize: number,
        +fileType: string,
        +fileUrl: string,
        +id: string,
        +name: string,
        +thumbnailUrl: ?string,
      |},
      +inviteScheduledAt: ?any,
      +invitedGroups: ?string,
      +landingPageHtml: ?string,
      +maxAdditionalGuests: ?number,
      +maxNoOfGuests: number,
      +message: string,
      +messageTitle: string,
      +placeName: string,
      +propertyId: string,
      +publishAt: ?any,
      +rsvpedCount: number,
      +startAt: any,
      +status: string,
      +title: string,
      +updatedAt: any,
      +eventType: string,
      +zoomLink: string,
      +meetingId: string,
      +passcode: string,
      +smsEnabled: ?boolean,
      +displayTime: ?string,
      +leadFields: ?$ReadOnlyArray<string>,
      +rsvpFormHeader: ?string,
      +emailList: ?any,
      +recurringEventType: ?string,
      +repeatType: ?string,
      +recurrenceType: ?string,
      +recurrenceEndDate: ?any,
      +recurringDaysList: ?string,
    |},
  |}
|};
export type updateEventMutation = {|
  variables: updateEventMutationVariables,
  response: updateEventMutationResponse,
|};
*/


/*
mutation updateEventMutation(
  $input: updateHyeventInput!
) {
  updateHyevent(input: $input) {
    clientMutationId
    hyevent {
      address
      additionalGuestAllowed
      approvedAt
      approverName
      cancelReason
      cancelledAt
      confirmPageHtml
      cancelRsvpPageHtml
      waitlistedPageHtml
      removeFromWaitlistPageHtml
      confirmSmsBody
      createdAt
      ctaText
      disapproveReason
      endAt
      flyerHtml
      id
      campaignTested
      image {
        createdAt
        dimension
        fileSize
        fileType
        fileUrl
        id
        name
        thumbnailUrl
      }
      document {
        createdAt
        dimension
        fileSize
        fileType
        fileUrl
        id
        name
        thumbnailUrl
      }
      inviteScheduledAt
      invitedGroups
      landingPageHtml
      maxAdditionalGuests
      maxNoOfGuests
      message
      messageTitle
      placeName
      propertyId
      publishAt
      rsvpedCount
      startAt
      status
      title
      updatedAt
      eventType
      zoomLink
      meetingId
      passcode
      smsEnabled
      displayTime
      leadFields
      rsvpFormHeader
      emailList
      recurringEventType
      repeatType
      recurrenceType
      recurrenceEndDate
      recurringDaysList
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "updateHyeventInput!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "createdAt",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v3 = [
  (v1/*: any*/),
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "dimension",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "fileSize",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "fileType",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "fileUrl",
    "args": null,
    "storageKey": null
  },
  (v2/*: any*/),
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "thumbnailUrl",
    "args": null,
    "storageKey": null
  }
],
v4 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "updateHyevent",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "updateHyeventPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "clientMutationId",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "hyevent",
        "storageKey": null,
        "args": null,
        "concreteType": "Hyevent",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "address",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "additionalGuestAllowed",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "approvedAt",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "approverName",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "cancelReason",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "cancelledAt",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "confirmPageHtml",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "cancelRsvpPageHtml",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "waitlistedPageHtml",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "removeFromWaitlistPageHtml",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "confirmSmsBody",
            "args": null,
            "storageKey": null
          },
          (v1/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "ctaText",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "disapproveReason",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "endAt",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "flyerHtml",
            "args": null,
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "campaignTested",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "image",
            "storageKey": null,
            "args": null,
            "concreteType": "Asset",
            "plural": false,
            "selections": (v3/*: any*/)
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "document",
            "storageKey": null,
            "args": null,
            "concreteType": "Asset",
            "plural": false,
            "selections": (v3/*: any*/)
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "inviteScheduledAt",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "invitedGroups",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "landingPageHtml",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "maxAdditionalGuests",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "maxNoOfGuests",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "message",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "messageTitle",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "placeName",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "propertyId",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "publishAt",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "rsvpedCount",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "startAt",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "status",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "title",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "updatedAt",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "eventType",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "zoomLink",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "meetingId",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "passcode",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "smsEnabled",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "displayTime",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "leadFields",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "rsvpFormHeader",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "emailList",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "recurringEventType",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "repeatType",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "recurrenceType",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "recurrenceEndDate",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "recurringDaysList",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "updateEventMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v4/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "updateEventMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v4/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "updateEventMutation",
    "id": null,
    "text": "mutation updateEventMutation(\n  $input: updateHyeventInput!\n) {\n  updateHyevent(input: $input) {\n    clientMutationId\n    hyevent {\n      address\n      additionalGuestAllowed\n      approvedAt\n      approverName\n      cancelReason\n      cancelledAt\n      confirmPageHtml\n      cancelRsvpPageHtml\n      waitlistedPageHtml\n      removeFromWaitlistPageHtml\n      confirmSmsBody\n      createdAt\n      ctaText\n      disapproveReason\n      endAt\n      flyerHtml\n      id\n      campaignTested\n      image {\n        createdAt\n        dimension\n        fileSize\n        fileType\n        fileUrl\n        id\n        name\n        thumbnailUrl\n      }\n      document {\n        createdAt\n        dimension\n        fileSize\n        fileType\n        fileUrl\n        id\n        name\n        thumbnailUrl\n      }\n      inviteScheduledAt\n      invitedGroups\n      landingPageHtml\n      maxAdditionalGuests\n      maxNoOfGuests\n      message\n      messageTitle\n      placeName\n      propertyId\n      publishAt\n      rsvpedCount\n      startAt\n      status\n      title\n      updatedAt\n      eventType\n      zoomLink\n      meetingId\n      passcode\n      smsEnabled\n      displayTime\n      leadFields\n      rsvpFormHeader\n      emailList\n      recurringEventType\n      repeatType\n      recurrenceType\n      recurrenceEndDate\n      recurringDaysList\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'b7756914cc43f9d9b5303614c40f6ebd';
module.exports = node;
